export function resolveCettleImage(image: any): string {
  if (!image) return "";
  if (typeof image === "string") return image;
  const url = image?.url;
  if (typeof url !== "string" || !url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const base = (process.env.NEXT_PUBLIC_CETTLE_BASE_URL ?? "").replace(
    /\/$/,
    "",
  );
  return `${base}${url}`;
}
